import React from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import { localRequest } from "../../helpers/uri";

const ReceiptHeader = ({ office, subs }) => {
  // Fetch system settings for dynamic header info
  const { data: settings } = useQuery({
    queryKey: ["systemSettings"],
    queryFn: async () => {
      const req = await axiosget("ms_system_settings/public");
      return req?.data;
    },
    staleTime: 1000 * 60 * 30, // Cache for 30 minutes
  });

  // Fetch officials
  const { data: officials } = useQuery({
    queryKey: ["institutionalOfficials"],
    queryFn: async () => {
      const req = await axiosget("ms_officials");
      return req?.data;
    },
    staleTime: 1000 * 60 * 30,
  });

  const getOfficial = (role) => {
    return officials?.find(v => v.role === role) || {};
  };

  const provost = getOfficial("Provost");
  const registrar = getOfficial("Registrar");

  const logoUrl = settings?.logo
    ? `${localRequest}${settings.logo.replace(/^\\/, '')}`
    : "/images/college-logo.png";

  return (
    <div className="receipt-header">
      {/* Logo at Top Center */}
      <div className="logo-section">
        <img
          src={logoUrl}
          alt="Institution Logo"
          className="institution-logo"
          onError={(e) => { e.target.src = "/images/college-logo.png"; }}
        />
      </div>

      {/* Institution Name */}
      <div className="institution-name">
        <h1>{settings?.institutionName || "Adamu Tafawa Balewa College of Education, Kangere"}</h1>
        <h3 className="state-name">BAUCHI STATE</h3>

        <div className="sub-text">CENTRAL ADMINISTRATION</div>
        <div className="address">
          {settings?.address || "KANGERE, BAUCHI STATE, NIGERIA"}
        </div>
      </div>

      {/* Officials Section */}
      <div className="officials-section">
        <div className="official">
          <div className="official-title">PROVOST:</div>
          <div className="official-name">
            {provost.name || "DR. BUTEH DAUDA SANDA"}
            {provost.accolades && <span className="credentials">{provost.accolades}</span>}
          </div>
        </div>
        <div className="official">
          <div className="official-title">REGISTRAR:</div>
          <div className="official-name">
            {registrar.name || "ALH. SAMBO ALIYU"}
            {registrar.accolades && <span className="credentials">{registrar.accolades}</span>}
          </div>
        </div>
      </div>

      {/* Office Title */}
      {office && (
        <div className="office-title">
          <div className="office-name">{office}</div>
          {subs && <small className="office-sub">{subs}</small>}
        </div>
      )}
    </div>
  );
};

export default ReceiptHeader;
